import { useBackgroundQuery } from '@apollo-internal/hooks/useBackgroundQuery';
import GET_APPRAISERS_DATA_FOR_EVENT from '../queries/appraisersDataForEventQuery';
import { useReactiveVar } from '@apollo/client';
import PrivilegeNames from '../../../constants/privilegeNames';
import { userInfo } from '@apollo-internal/cache';
import { AppraisersProfileMapper } from '../mappers/AppraisersProfileMapper';

export const useGetAppraisersProfileQuery = eventId => {
  const currentUserInfo = useReactiveVar(userInfo);

  const { data, loading, error } = useBackgroundQuery(GET_APPRAISERS_DATA_FOR_EVENT, {
    fetchPolicy: 'cache-and-network',
    variables: {
      eventId
    },
    skip: !(
      currentUserInfo.Privileges.includes(PrivilegeNames.Calendar_EditEvent_ViewAtlPreferences) ||
      currentUserInfo.Privileges.includes(PrivilegeNames.Calendar_EditEvent_TeamAssignment)
    )
  });

  return {
    data: AppraisersProfileMapper.mapAppraisersDataForEvent(data?.appraisersDataForEvent) || [],
    isDataAvailable: loading || Boolean(error)
  };
};
